<div
    class="data-card-grid"
    [style.--data-card-grid-columns]="gridLayout().columns"
    [style.height.px]="gridLayout().height">
    @for (part of card()?.parts; track part.id) {
        <div
            class="data-card-grid__item"
            [style.grid-column-start]="part.x + 1"
            [style.grid-column-end]="'span ' + part.cols"
            [style.grid-row-start]="part.y + 1"
            [style.grid-row-end]="'span ' + part.effectiveRows">
            <app-data-card-view-part [part]="part"></app-data-card-view-part>
        </div>
    }
</div>
@if (actionsFiltered().length) {
    <button
        mat-icon-button
        [matMenuTriggerFor]="cardActionsMenu"
        [attr.aria-label]="'a11y.common.more' | translate"
        type="button"
        class="card-actions"
        data-testid="datacard-actions-button-trigger"
        (click)="$event.stopPropagation()">
        <mat-icon aria-hidden="true">more_vert</mat-icon>
    </button>
    <mat-menu #cardActionsMenu="matMenu" class="cipo">
        @for (
            action of actionsFiltered();
            track action.actionType === dividerActionType ? "divider-" + $index : (action.actionType ?? action.name)
        ) {
            @if (action.actionType === dividerActionType) {
                <div role="separator" class="cipo--border-bottom--lite m-x-sm"></div>
            } @else {
                <button
                    mat-menu-item
                    [attr.data-testid]="
                        'datacard-actions-button-menu-item datacard-actions-button-menu-item-' +
                        (action.actionType ?? action.name)
                    "
                    (click)="cardActionClick(action)">
                    @if (action.matIcon) {
                        <mat-icon>{{ action.matIcon }}</mat-icon>
                    }
                    <span>{{ action.name | translate }}</span>
                </button>
            }
        }
    </mat-menu>
}
